<template>
    <div class="modal-body">
        <b-row>
            <label class="sa-label-data">{{ this.$i18n.t("patient.agenda.lblPerformanceCode") }}</label>
            <b-form-input name="codicePrestazione" class="form-control" v-model="setCodicePrestazione"></b-form-input>
        </b-row>

        <b-row>
            <label class="sa-label-data">{{ this.$i18n.t("patient.agenda.lblDescriptionPerformance") }}</label>
            <b-form-textarea v-model="setDescrizione" rows="5" no-resize></b-form-textarea>
        </b-row>

        <b-row>
            <label class="sa-label-data">{{ this.$i18n.t("patient.agenda.lblCost") }}</label>
            <b-form-input v-model="setCosto"> </b-form-input>
        </b-row>

        <b-row>
            <label class="sa-label-data">{{ this.$i18n.t("agenda.lblDuration") }}</label>
            <b-form-input type="number" name="durata" class="form-control" v-model="setDurata"> </b-form-input>
        </b-row>
    </div>
</template>
<script>
export default {
    props: {
        jsonData: {
            type: Object,
            default: function () {
                return { codicePrestazione: null, descrizionePrestazione: null, costo: null, durata: null };
            },
        },
    },
    data() {
        return {};
    },
    computed: {
        setDurata: {
            get: function () {
                return this.jsonData.durata;
            },
            set: function (value) {
                this.jsonData.durata = value;
            },
        },
        setDescrizione: {
            get: function () {
                return this.jsonData.descrizionePrestazione;
            },
            set: function (value) {
                this.jsonData.descrizionePrestazione = value;
            },
        },
        setCosto: {
            get: function () {
                return this.jsonData.costo;
            },
            set: function (value) {
                this.jsonData.costo = value;
            },
        },
        setCodicePrestazione: {
            get: function () {
                return this.jsonData.codicePrestazione;
            },
            set: function (value) {
                this.jsonData.codicePrestazione = value;
            },
        },
    },
};
</script>
<style></style>
